import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { ICNDDistrict } from 'src/models/cnd-district.model';
import services from 'src/services/cnd-district.service';

export const actionTypes = {
  CND_DISTRICT_LIST_FETCH: 'CND_DISTRICT_LIST_FETCH',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.CND_DISTRICT_LIST_FETCH,
    service: services.listGET,
  },
};

export type ICNDDistrictAsync = typeof asyncActions;
export interface ICNDDistrictState extends ICommonState<ICNDDistrictAsync> {
  data?: ICNDDistrict;
  list: ICNDDistrict[];
  total: number;
}

export const defaultState: ICNDDistrictState = {
  status: {},
  list: [],
  total: 0,
};

const CNDDistrictReducer = (
  state: ICNDDistrictState = defaultState,
  action: IReducerAction<ICNDDistrictAsync>
): ICNDDistrictState => {
  switch (action.type) {
    case actionTypes.CND_DISTRICT_LIST_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
        total: action.payload?.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default CNDDistrictReducer;
